import React from "react";
import { ButtonProps } from "@material-ui/core";

import * as S from "./styles";

const Button = ({ children, ...rest }: ButtonProps) => {
  return (
    <S.Button variant="contained" {...rest}>
      {children}
    </S.Button>
  );
};

export default Button;
